//Action Types
export const FETCH_COMPANY = 'FETCH_COMPANY';

//Action Creator
export const fetchCompany = (data) => ({
   type: FETCH_COMPANY,
   data: data
});
